import { render, staticRenderFns } from "./DesktopOnlyModal.vue?vue&type=template&id=47dfada2&scoped=true&"
import script from "./DesktopOnlyModal.vue?vue&type=script&lang=ts&"
export * from "./DesktopOnlyModal.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopOnlyModal.vue?vue&type=style&index=0&id=47dfada2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dfada2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('47dfada2', component.options)
    } else {
      api.reload('47dfada2', component.options)
    }
    module.hot.accept("./DesktopOnlyModal.vue?vue&type=template&id=47dfada2&scoped=true&", function () {
      api.rerender('47dfada2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/DesktopOnlyModal.vue"
export default component.exports